var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkiing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6740E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0015 8.61842C22.1174 9.29969 20.8481 9.13601 20.1661 8.25299C19.4842 7.36999 19.6479 6.10186 20.532 5.4206C21.4161 4.73933 22.6854 4.903 23.3675 5.78603C24.0495 6.66902 23.8858 7.93715 23.0015 8.61842H23.0015Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32025 21.2998L20.8557 26.9476C21.5912 27.2151 22.3918 26.8405 22.6597 26.1052L22.7842 25.7609L23.6651 26.0813L23.5406 26.4275C23.0994 27.6387 21.7469 28.2689 20.5355 27.8285L5 22.1806L5.32025 21.2998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7095 8.63872C18.9182 8.63872 19.1279 8.68372 19.3321 8.75782C20.2354 9.14417 20.6551 10.1896 20.2679 11.0927L19.8338 12.2794L23.3829 13.5706C23.8695 13.7474 24.1204 14.2855 23.9434 14.7719L23.8938 14.9057C23.7165 15.3923 23.179 15.643 22.6924 15.466C18.4167 13.8975 9.75553 10.7631 9.75553 10.7631L9.53221 11.3765L8.6513 11.0561L8.87483 10.4427L7.38965 9.90247L7.71008 9.02157L9.19714 9.56176L9.42067 8.9502L10.3016 9.27063L10.078 9.88219L15.3266 11.7905L17.0811 9.4318C17.4698 8.90877 18.0813 8.6235 18.7074 8.63877L18.7095 8.63872Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1679 13.356L17.2684 14.4841L15.6714 16.4932L17.3636 17.6652C18.4454 18.4149 18.7479 19.8821 18.0503 20.9983L15.2869 25.4209L12.9648 24.5766L15.5379 20.8553C15.7907 20.4895 15.6959 19.9888 15.3271 19.74L13.3109 18.3793C12.267 17.675 12.0232 16.242 12.7743 15.2313L14.1679 13.356Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiing);
export default __webpack_public_path__ + "static/media/Skiing.a1b6dc670ebf70e7189bb1869c59cf50.svg";
export { ForwardRef as ReactComponent };